import PropTypes from 'prop-types'

import Injector from '@s-ui/react-primitive-injector'

import {CHECK_ELEMENT_TYPES, CHECK_ELEMENTS} from '../../config.js'

const CheckElement = ({
  id,
  imageSrc,
  isChecked,
  isIndeterminate,
  label,
  onChange,
  type = CHECK_ELEMENT_TYPES.CHECKBOX
}) => {
  const Component = CHECK_ELEMENTS[type]

  return (
    <Injector
      id={id}
      imageSrc={imageSrc}
      isChecked={isChecked}
      isIndeterminate={isIndeterminate}
      label={label}
      onChange={onChange}
    >
      {Component}
    </Injector>
  )
}

CheckElement.displayName = 'CheckElement'
CheckElement.propTypes = {
  id: PropTypes.string,
  imageSrc: PropTypes.string,
  isChecked: PropTypes.bool,
  isIndeterminate: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string
}

export default CheckElement
